import Utils from "./utils";
import * as THREE from 'three';
import $ from "jquery";

/**
 *
 */
class ParticlesWave {

	/**
	 *
	 * @param options
	 */
	constructor(Bulb) {

		// on construit que si nécessaire
		if($('#engagement__canvas').length === 0){
			return false;
		}

		Utils.debug('Construct Wave Points');

		this.bulb = Bulb;

		this.init();

	}

	/**
	 * Init
	 */
	init() {
		var SEPARATION = 100, AMOUNTX = 50, AMOUNTY = 50;

		var container;
		var camera, scene, renderer;

		var particles, count = 0;

		var mouseX = 0, mouseY = 0;

		var windowHalfX = window.innerWidth / 2;
		var windowHalfY = window.innerHeight / 2;

		init();
		animate();

		function init() {

			container = document.getElementById("engagement__canvas");

			camera = new THREE.PerspectiveCamera( 50, window.innerWidth / window.innerHeight, 1, 10000 );
			camera.position.y = 450;
			camera.position.z = 1500;
			camera.rotation.x = 0;


			scene = new THREE.Scene();

			//

			var numParticles = AMOUNTX * AMOUNTY;

			var positions = new Float32Array( numParticles * 3 );
			var scales = new Float32Array( numParticles );

			var i = 0, j = 0;

			for ( var ix = 0; ix < AMOUNTX; ix ++ ) {

				for ( var iy = 0; iy < AMOUNTY; iy ++ ) {

					positions[ i ] = ix * SEPARATION - ( ( AMOUNTX * SEPARATION ) / 2 ); // x
					positions[ i + 1 ] = 0; // y
					positions[ i + 2 ] = iy * SEPARATION - ( ( AMOUNTY * SEPARATION ) / 2 ); // z

					scales[ j ] = 1;

					i += 3;
					j ++;

				}

			}

			// TODO : VertexShader & fragmentShader à Optimiser
			var geometry = new THREE.BufferGeometry();
			geometry.setAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );
			geometry.setAttribute( 'scale', new THREE.BufferAttribute( scales, 1 ) );

			var material = new THREE.ShaderMaterial( {

				uniforms: {
					color: { value: new THREE.Color( 0xC20006 ) },
				},
				vertexShader: document.getElementById( 'vertexshader' ).textContent,
				fragmentShader: document.getElementById( 'fragmentshader' ).textContent

			} );

			//

			particles = new THREE.Points( geometry, material );
			scene.add( particles );

			//

			renderer = new THREE.WebGLRenderer( { antialias: true } );
			renderer.setPixelRatio( window.devicePixelRatio );
			renderer.setSize( window.innerWidth, window.innerHeight / 3.5 );
			renderer.setClearColor( 0x01090F, 1);
			container.appendChild( renderer.domElement );

			container.style.touchAction = 'none';

			window.addEventListener( 'resize', onWindowResize, false );

		}

		function onWindowResize() {

			windowHalfX = window.innerWidth / 2;
			windowHalfY = window.innerHeight / 2;

			camera.aspect = window.innerWidth / window.innerHeight;
			camera.updateProjectionMatrix();

			renderer.setSize( window.innerWidth, window.innerHeight / 3.5 );

		}

		function animate() {
			requestAnimationFrame( animate );
			render();
		}

		function render() {
			camera.lookAt( scene.position );

			var positions = particles.geometry.attributes.position.array;
			var scales = particles.geometry.attributes.scale.array;

			var i = 0, j = 0;

			for ( var ix = 0; ix < AMOUNTX; ix ++ ) {

				for ( var iy = 0; iy < AMOUNTY; iy ++ ) {

					positions[ i + 1 ] = ( Math.sin( ( ix + count ) * 0.3 ) * 50 ) +
						( Math.sin( ( iy + count ) * 0.5 ) * 50 );

					scales[ j ] = ( Math.sin( ( ix + count ) * 0.3 ) + 1 ) * 20 +
						( Math.sin( ( iy + count ) * 0.5 ) + 1 ) * 20;

					i += 3;
					j ++;

				}

			}

			particles.geometry.attributes.position.needsUpdate = true;
			particles.geometry.attributes.scale.needsUpdate = true;

			renderer.render( scene, camera );

			count += 0.1;

		}
	}

}

export default ParticlesWave;
